import { z } from 'zod'

const firebaseConfigSchema = z.object({
  VITE_PUBLIC_FIREBASE_API_KEY: z.string(),
  VITE_PUBLIC_FIREBASE_AUTH_DOMAIN: z.string(),
  VITE_PUBLIC_FIREBASE_PROJECT_ID: z.string(),
  VITE_PUBLIC_FIREBASE_STORAGE_BUCKET: z.string(),
  VITE_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: z.string(),
  VITE_PUBLIC_FIREBASE_APP_ID: z.string(),
  VITE_PUBLIC_FIREBASE_MEASUREMENT_ID: z.string(),
});

const firebaseConfigEnv = firebaseConfigSchema.parse(import.meta.env);

export const firebaseConfig = {
  apiKey: firebaseConfigEnv.VITE_PUBLIC_FIREBASE_API_KEY,
  authDomain: firebaseConfigEnv.VITE_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: firebaseConfigEnv.VITE_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: firebaseConfigEnv.VITE_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: firebaseConfigEnv.VITE_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: firebaseConfigEnv.VITE_PUBLIC_FIREBASE_APP_ID,
  measurementId: firebaseConfigEnv.VITE_PUBLIC_FIREBASE_MEASUREMENT_ID
};